import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../../lib/utils";

export const Route = createFileRoute("/lessons/$slug")({
  head: () => pageHead("page.lesson"),
});
